<template>
  <v-row>
    <v-col cols="12" lg="6">
      <v-card>
        <v-card-title>
          {{ $t("admin.user.data.user.title") }}
        </v-card-title>

        <v-simple-table>
          <template #default>
            <tbody>
              <tr>
                <td width="40%">
                  {{ $t("admin.user.data.user.firstname") }}
                </td>
                <td>{{ user.firstname }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.user.lastname") }}</td>
                <td>{{ user.lastname }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.user.email") }}</td>
                <td>{{ user.email }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.user.emails") }}</td>
                <td>
                  <v-chip small v-for="val in user.emails" :key="val">
                    {{ val }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>

    <v-col cols="12" lg="6">
      <v-card>
        <v-card-title>
          {{ $t("admin.user.data.company.title") }}
        </v-card-title>

        <v-simple-table>
          <template #default>
            <tbody>
              <tr>
                <td width="40%">
                  {{ $t("admin.user.data.company.name") }}
                </td>
                <td>{{ user.company.address.name }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.company.contactPerson") }}</td>
                <td>{{ user.company.address.contactPerson }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.company.phone") }}</td>
                <td>{{ user.company.address.phone }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.company.website") }}</td>
                <td>{{ user.company.address.website }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.company.currency") }}</td>
                <td>{{ user.company.address.currency }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t("admin.user.data.company.sustainedCapital") }}
                </td>
                <td>
                  <BaseNumeral :number="user.company.address.sustainedCapital" format="0,0[.][0000]" />
                </td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.company.totalCapital") }}</td>
                <td>
                  <BaseNumeral :number="user.company.address.totalCapital" format="0,0[.][0000]" />
                </td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.address.vatId") }}</td>
                <td>{{ user.company.address.vatId }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>

    <v-col cols="12" lg="6">
      <v-card>
        <v-card-title>
          {{ $t("admin.user.data.address.title") }}
        </v-card-title>

        <v-simple-table>
          <template #default>
            <tbody>
              <tr>
                <td width="40%">
                  {{ $t("admin.user.data.address.address") }}
                </td>
                <td>{{ user.company.address.address }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.address.city") }}</td>
                <td>{{ user.company.address.city }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.address.zip") }}</td>
                <td>{{ user.company.address.zip }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.address.country") }}</td>
                <td>
                  {{ user.company.address.country && $t(`countries.${user.company.address.country}`) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>

    <v-col cols="12" lg="6" v-if="user.useBillingAddress">
      <v-card>
        <v-card-title>
          {{ $t("admin.user.data.billingAddress.title") }}
        </v-card-title>

        <v-simple-table>
          <template #default>
            <tbody>
              <tr>
                <td width="40%">
                  {{ $t("admin.user.data.billingAddress.name") }}
                </td>
                <td>{{ user.company.billingAddress.name }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.billingAddress.contactPerson") }}</td>
                <td>{{ user.company.billingAddress.contactPerson }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t("admin.user.data.billingAddress.address") }}
                </td>
                <td>{{ user.company.billingAddress.address }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.billingAddress.city") }}</td>
                <td>{{ user.company.billingAddress.city }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.billingAddress.zip") }}</td>
                <td>{{ user.company.billingAddress.zip }}</td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.billingAddress.country") }}</td>
                <td>
                  {{ user.company.address.billingAddress && $t(`countries.${user.company.billingAddress.country}`) }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("admin.user.data.billingAddress.vatId") }}</td>
                <td>{{ user.company.billingAddress.vatId }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
